/* RITTAL landing · pestañas del showcase de producto. Soporta varias instancias. */
(function () {
  function initShow(sec) {
    var tabs = [].slice.call(sec.querySelectorAll('.rt-tb'));
    var panels = [].slice.call(sec.querySelectorAll('.rt-panel'));
    if (!tabs.length) return;
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.setAttribute('aria-selected', 'false'); });
        t.setAttribute('aria-selected', 'true');
        panels.forEach(function (p) { p.classList.toggle('on', p.getAttribute('data-idx') === t.getAttribute('data-idx')); });
      });
    });
  }
  function boot() { [].slice.call(document.querySelectorAll('.rt-show')).forEach(initShow); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Reinit al recargar la sección en el editor de temas
  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector ? e.target.querySelector('.rt-show') : null;
    if (sec) initShow(sec);
  });
})();
